import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { OfferInterface } from '@sport-activities/sdk';

import { BadgeVariantEnum } from '~/component/badge/enums/variant.enum';
import { ValueAccessorBase } from '~/component/value-accessor.base';
import { Activity } from '~/core/model/activity.model';
import isBulgaria from '~/core/helpers/country/country.helper';
import { ParamethorService } from '~/paramethor/paramethor.service';
import { ParamethorNameEnum } from '~/paramethor/names.enum';

@Component({
  selector: 'app-offer-collection',
  templateUrl: './offer-collection.component.html',
  styleUrls: ['./offer-collection.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OfferCollectionComponent,
      multi: true,
    },
  ],
})
// eslint-disable @typescript-eslint/no-explicit-any
export class OfferCollectionComponent
  extends ValueAccessorBase<any>
  implements OnInit
{
  @Input() public activity: Activity;
  @Input() public isMobileDevice = false;
  @Input() public offers: OfferInterface[];
  @Output() public handleMobileSelection = new EventEmitter();
  @Output() public selectedOffer = new EventEmitter<OfferInterface>();
  public badgeVariant = BadgeVariantEnum;

  public offersForm: FormControl;

  constructor(private readonly paramethorService: ParamethorService) {
    super();
  }

  public ngOnInit(): void {
    this.offersForm = new FormControl(
      // if there is only one offer select it by default  //
      this.offers?.length === 1 ? this.offers?.[0] : '',
      Validators.required
    );

    this.offersForm.valueChanges.subscribe((value) => {
      this.selectedOffer.emit(value);
    });
  }

  public get isBg(): boolean {
    return isBulgaria();
  }

  public get showExternalPaymentBadge(): boolean {
    return (
      this.paramethorService.isTrue(ParamethorNameEnum.AllowExternalPayment) &&
      this.activity.startingPrice?.amount > 0
    );
  }

  public handleClickOnFormulaForMobile(): void {
    if (this.isMobileDevice) {
      this.handleMobileSelection.emit();
    }
  }

  public isSelected(offer: OfferInterface): boolean {
    return this.value?.identifier === offer?.identifier;
  }
}
